import React, { useState, useEffect } from 'react';
import UserServices from "../../services/UserServices";
import BookingServices from "../../services/BookingServices";

function BookingUpdate({ order, closeModal, onSuccess }) {
  
  const [vendors, setVendors] = useState([]);  // Initialize as an empty array
  const [selectedVendor, setSelectedVendor] = useState("");

  // Fetch vendors when order changes
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await UserServices.getAllActiveVendor();

        // Ensure the response has a 'data' property and it's an array
        if (response && Array.isArray(response.data)) {
          setVendors(response.data);  // Set vendors from response.data
        } else {
          console.error("Vendors data is not in the correct format:", response);
          setVendors([]);  // Set vendors to an empty array if the response is not valid
        }
      } catch (error) {
        console.error("Failed to fetch vendors:", error);
        setVendors([]);  // Set vendors to an empty array on error
      }
    };

    fetchVendors();
  }, [order]);

  // Handle assigning the vendor to the order
  const handleAssign = async (e) => {
    e.preventDefault();  // Prevent form submission
    if (!selectedVendor) {
      alert("Please select a service partner");
      return;
    }

    try {
      // Pass both order._id and selectedVendor to the service
      await BookingServices.assignVendor({
        bookingId: order._id,
        vendorId: selectedVendor
      });
      alert('Booking Assign Successfully');
      onSuccess();  // Call the onSuccess callback after success
      closeModal(); // Close the modal after successful assignment
    } catch (error) {
      console.error("Failed to assign Booking:", error);
      alert(error.response?.data?.message || 'Failed to assign Booking');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Assign Service Partner</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleAssign}>
                    <div className="row">
                      <div className="col-lg-13 col-sm-12">
                        <div className="input-field">
                          <label>Assign Partner</label>
                          <select
                            id="vendor"
                            className="form-control"
                            value={selectedVendor}
                            onChange={(e) => setSelectedVendor(e.target.value)}
                          >
                            <option value="">--Select Service Partner--</option>
                            {vendors.length > 0 ? (
                              vendors.map((vendor) => (
                                <option key={vendor._id} value={vendor._id}>
                                  Name: {vendor.name} and Mobile No: {vendor.mobileNo}
                                </option>
                              ))
                            ) : (
                              <option value="">No vendors available</option>
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                    <button className="submit-green-btn" type="submit">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingUpdate;
